import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { CookingMode } from '../features/cooking/CookingMode.tsx';

const cookSearchSchema = z.object({
  /** Zero-based step, kept in the URL so a reload resumes there. */
  step: z.coerce.number().int().min(0).max(200).optional().catch(undefined),
  portions: z.coerce.number().int().min(1).max(99).optional().catch(undefined),
});

export const Route = createFileRoute('/recipes/$id_/cook')({
  validateSearch: (search) => cookSearchSchema.parse(search),
  component: CookingScreen,
});

function CookingScreen() {
  const { id } = Route.useParams();
  const search = Route.useSearch();
  const navigate = useNavigate({ from: '/recipes/$id/cook' });
  return (
    <CookingMode
      id={id}
      step={search.step ?? 0}
      portions={search.portions}
      onStep={(step) => void navigate({ search: (s) => ({ ...s, step }), replace: true })}
      onPortions={(portions) =>
        void navigate({ search: (s) => ({ ...s, portions }), replace: true })
      }
    />
  );
}
